/* ============================================================
   BARRA FIJA DE COMPRA — v3 (2 sep 2026)

   Sale en MOVIL Y EN ESCRITORIO cuando el boton de comprar de verdad se va
   de la pantalla. Ahora lleva ademas SELECTORES DE OPCION (talla, color) y
   CANTIDAD, copiado de la barra de gudslip.com.

   MEDIDO EN VIVO en su `.gudslip-pdp__sticky` a 1440x900:
     barra          81 px de alto, borde superior 1px, sombra 0 -8px 24px
     interior       flex, gap 16, padding 12px 32px
     foto           56 x 56, radio 8
     titulo         16px / 500
     select         44 de alto, radio 8, borde 1px, texto 13px
     cantidad       104 x 44, radio 8, borde 1px (botones de 34 x 42)
     boton          44 de alto, radio 8, padding 0 20, texto 16px / 600

   🚩 LA BARRA NO SABE NADA DE VARIANTES: ES UN MANDO A DISTANCIA.
   Los selectores NO calculan que variante toca. Cada `<select>` se construye
   leyendo las pastillas `[data-valor]` de la ficha, y al cambiarlo lo unico
   que hace es PULSAR la pastilla que corresponde. La cantidad se escribe en
   el `input[name="quantity"]` del formulario real. Asi solo hay una fuente
   de verdad — la seccion de producto — y no pueden desincronizarse.

   ⚠️ EN ESCRITORIO LA COLUMNA DE COMPRA ES STICKY (top: 90px), asi que el
   boton real sigue en pantalla durante casi toda la ficha y la barra NO
   aparece hasta que esa columna se va — Momentos, Estilos parecidos,
   resenas, pie. Es el comportamiento que se quiere.

   🚩 ESTA PLANTILLA NO HACE SCROLL EN LA VENTANA.
   Horizon pone `overflow:hidden` en <html> y en <body> (los dos a 100vh) y
   el que se desplaza es `.page-wrapper`. `window.pageYOffset` se queda
   SIEMPRE en 0 y el evento 'scroll' del contenedor NO burbujea hasta window.
   Por eso hay `contenedor()` y se escucha el scroll en los dos sitios.

   ⚠️ LOS PACKS MANDAN. `pn-pack.js` pinta su propio bloque con sus tallas
   (`.pn-pack__size`) y su propio boton (`.pn-pack__add`). Si existe, la
   barra usa ESE boton y ESAS tallas. Se construye despues de un fetch, de
   ahi el reintento de los primeros segundos.

   ⚠️ ESCRIBIR EN LA FICHA DISPARA EL MutationObserver DE ESTE FICHERO. Por
   eso `refrescar()` solo escribe cuando el valor CAMBIA. Sin ese freno se
   entra en bucle de repintado.
   ============================================================ */
(function () {
  if (window.__pnBarraFija) { return; }
  window.__pnBarraFija = true;

  var MIN_SCROLL = 300;

  var CSS = [
    '.pn-barra{position:fixed;left:0;right:0;bottom:0;z-index:40;',
    'background:var(--pn-caja-fondo,#f7f2e9);border-top:1px solid var(--pn-borde,#cfc7b8);',
    'box-shadow:0 -8px 24px rgba(26,26,26,.08);',
    'font-family:var(--pn-fuente-texto),sans-serif;',
    'transform:translateY(110%);visibility:hidden;transition:transform .22s ease}',
    '.pn-barra--visible{transform:none;visibility:visible}',

    '.pn-barra__inner{display:flex;align-items:center;gap:16px;',
    'max-width:1340px;margin:0 auto;padding:12px 24px;',
    'padding-bottom:calc(12px + env(safe-area-inset-bottom))}',

    '.pn-barra__media{flex:0 0 auto;width:56px;height:56px;border-radius:8px;overflow:hidden;background:#ede2d0}',
    '.pn-barra__foto{width:100%;height:100%;object-fit:cover;display:block}',

    '.pn-barra__nombre{flex:1 1 auto;min-width:0;font-size:16px;font-weight:500;line-height:1.3;',
    'color:var(--pn-texto,#4a453f);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}',

    '.pn-barra__ops{display:flex;align-items:center;gap:8px;flex:0 0 auto}',
    '.pn-barra__sel{height:44px;border-radius:8px;border:1px solid var(--pn-borde,#cfc7b8);',
    'background:#fff;color:var(--pn-precio,#1a1a1a);font-family:inherit;font-size:13px;',
    'padding:0 34px 0 14px;cursor:pointer;appearance:none;-webkit-appearance:none;',
    'background-image:url("data:image/svg+xml;charset=utf8,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 24 24\' fill=\'none\' stroke=\'%231a1a1a\' stroke-width=\'2\' stroke-linecap=\'round\'%3E%3Cpath d=\'M6 9l6 6 6-6\'/%3E%3C/svg%3E");',
    'background-repeat:no-repeat;background-position:right 12px center;background-size:14px}',

    '.pn-barra__qty{flex:0 0 auto;display:flex;align-items:center;justify-content:space-between;',
    'width:104px;height:44px;border-radius:8px;border:1px solid var(--pn-borde,#cfc7b8);background:#fff}',
    '.pn-barra__qty button{width:34px;height:42px;border:0;background:none;cursor:pointer;',
    'font-family:inherit;font-size:16px;line-height:1;color:var(--pn-precio,#1a1a1a);padding:0}',
    '.pn-barra__qty button[disabled]{opacity:.35;cursor:default}',
    '.pn-barra__qty-num{font-size:15px;font-weight:500;color:var(--pn-precio,#1a1a1a);min-width:16px;text-align:center}',

    '.pn-barra__boton{flex:0 0 auto;height:44px;padding:0 20px;border:0;border-radius:8px;',
    'background:var(--pn-boton-fondo,#1a1a1a);color:var(--pn-boton-texto,#f4f1eb);',
    'font-family:inherit;font-size:16px;font-weight:600;white-space:nowrap;cursor:pointer}',
    '.pn-barra__boton[disabled]{opacity:.45;cursor:default}',

    /* ⚠️ MOVIL EN DOS FILAS. Dos selectores + cantidad + boton no caben en
       375 px en una sola linea: o se aplastan o se salen. Arriba las
       opciones, abajo cantidad y boton. La foto y el nombre sobran ahi. */
    '@media (max-width:749px){',
      '.pn-barra__inner{flex-wrap:wrap;gap:10px;padding:10px 14px;',
      'padding-bottom:calc(10px + env(safe-area-inset-bottom))}',
      '.pn-barra__media,.pn-barra__nombre{display:none}',
      '.pn-barra__ops{flex:1 1 100%;gap:8px}',
      '.pn-barra__sel{flex:1 1 0;min-width:0;height:42px}',
      '.pn-barra__qty{height:42px}',
      '.pn-barra__boton{flex:1 1 auto;height:42px;font-size:15px;padding:0 12px}',
    '}',

    '.pn-barra-resalte{border-radius:12px;animation:pn-barra-pulso 1.2s ease}',
    '@keyframes pn-barra-pulso{0%,100%{box-shadow:0 0 0 0 rgba(185,142,126,0)}35%{box-shadow:0 0 0 5px rgba(185,142,126,.45)}}',
    '@media (prefers-reduced-motion:reduce){.pn-barra{transition:none}.pn-barra-resalte{animation:none}}'
  ].join('');

  function contenedor() {
    var w = document.querySelector('.page-wrapper');
    if (!w) { return null; }
    var o = getComputedStyle(w).overflowY;
    return (o === 'auto' || o === 'scroll') ? w : null;
  }

  function desplazamiento() {
    var c = contenedor();
    if (c && c.scrollTop > 0) { return c.scrollTop; }
    if (window.pageYOffset > 0) { return window.pageYOffset; }
    return c ? c.scrollTop : 0;
  }

  function arrancar() {
    var raiz = document.querySelector('[data-producto-nazalea]');
    if (!raiz || document.querySelector('.pn-barra')) { return; }

    var estilo = document.createElement('style');
    estilo.textContent = CSS;
    document.head.appendChild(estilo);

    var barra = document.createElement('div');
    barra.className = 'pn-barra';
    barra.innerHTML =
      '<div class="pn-barra__inner">' +
        '<span class="pn-barra__media"><img class="pn-barra__foto" alt="" loading="lazy" decoding="async"></span>' +
        '<span class="pn-barra__nombre"></span>' +
        '<span class="pn-barra__ops"></span>' +
        '<span class="pn-barra__qty">' +
          '<button type="button" data-pn-q="-1" aria-label="Quitar una">−</button>' +
          '<span class="pn-barra__qty-num">1</span>' +
          '<button type="button" data-pn-q="1" aria-label="Añadir una">+</button>' +
        '</span>' +
        '<button class="pn-barra__boton" type="button"></button>' +
      '</div>';

    /* Hereda los colores y la fuente reales de la ficha. */
    var cs = getComputedStyle(raiz);
    var vars = ['--pn-caja-fondo', '--pn-borde', '--pn-texto', '--pn-precio', '--pn-tachado',
      '--pn-boton-fondo', '--pn-boton-texto', '--pn-fuente-texto'];
    for (var i = 0; i < vars.length; i++) {
      var v = cs.getPropertyValue(vars[i]);
      if (v && v.trim()) { barra.style.setProperty(vars[i], v.trim()); }
    }

    document.body.appendChild(barra);

    var elFoto = barra.querySelector('.pn-barra__foto');
    var elNombre = barra.querySelector('.pn-barra__nombre');
    var elOps = barra.querySelector('.pn-barra__ops');
    var elQtyNum = barra.querySelector('.pn-barra__qty-num');
    var elMenos = barra.querySelector('[data-pn-q="-1"]');
    var elMas = barra.querySelector('[data-pn-q="1"]');
    var elBoton = barra.querySelector('.pn-barra__boton');

    var og = document.querySelector('meta[property="og:image"]');
    if (og && og.content) {
      /* og:image llega en http:// y la pagina va en https -> contenido mixto. */
      elFoto.src = og.content.replace(/^http:/, 'https:').split('&width=')[0] + '&width=160';
    } else {
      var primera = raiz.querySelector('.producto-nazalea__foto img, .producto-nazalea__mini img');
      if (primera) { elFoto.src = primera.currentSrc || primera.src; }
    }

    var tituloEl = raiz.querySelector('.producto-nazalea__titulo');
    var nombreBase = tituloEl ? tituloEl.textContent.trim() : '';

    /* ---------- de donde se leen las opciones ---------- */

    function destino() {
      return document.querySelector('.pn-pack__add') || raiz.querySelector('.producto-nazalea__boton');
    }

    /* Devuelve [{nombre, valores:[{valor, activo, el}]}] leyendo la ficha.
       Si hay packs, sus tallas mandan (ver el aviso de la cabecera). */
    function opciones() {
      var packs = document.querySelectorAll('.pn-pack__size');
      if (packs.length) {
        var vals = [];
        Array.prototype.forEach.call(packs, function (p) {
          vals.push({ valor: p.textContent.trim(), activo: /is-sel/.test(p.className), el: p });
        });
        return [{ nombre: 'Talla', valores: vals }];
      }
      var out = [];
      var grupos = raiz.querySelectorAll('[data-grupo]');
      Array.prototype.forEach.call(grupos, function (g) {
        var vals = [];
        Array.prototype.forEach.call(g.querySelectorAll('[data-valor]'), function (v) {
          vals.push({
            valor: v.getAttribute('data-valor'),
            activo: /--activo/.test(v.className),
            el: v
          });
        });
        if (vals.length) {
          out.push({ nombre: g.hasAttribute('data-es-color') ? 'Color' : 'Talla', valores: vals });
        }
      });
      return out;
    }

    /* Firma de las opciones: si no cambia, no se reconstruyen los selects.
       Sin esto se pierde el foco del desplegable en cada repintado. */
    function firmaOpciones(ops) {
      var s = '';
      for (var i = 0; i < ops.length; i++) {
        s += ops[i].nombre + ':';
        for (var j = 0; j < ops[i].valores.length; j++) {
          s += ops[i].valores[j].valor + (ops[i].valores[j].activo ? '*' : '') + ',';
        }
        s += '|';
      }
      return s;
    }

    var firmaPuesta = '';

    function pintarOpciones() {
      var ops = opciones();
      var f = firmaOpciones(ops);
      if (f === firmaPuesta) { return; }
      firmaPuesta = f;

      elOps.innerHTML = '';
      ops.forEach(function (op, idx) {
        var sel = document.createElement('select');
        sel.className = 'pn-barra__sel';
        sel.setAttribute('aria-label', op.nombre);
        op.valores.forEach(function (v) {
          var o = document.createElement('option');
          o.value = v.valor;
          o.textContent = v.valor;
          if (v.activo) { o.selected = true; }
          sel.appendChild(o);
        });
        sel.addEventListener('change', function () {
          var actuales = opciones()[idx];
          if (!actuales) { return; }
          for (var k = 0; k < actuales.valores.length; k++) {
            if (actuales.valores[k].valor === sel.value) {
              actuales.valores[k].el.click();
              break;
            }
          }
        });
        elOps.appendChild(sel);
      });
    }

    /* ---------- cantidad ----------
       Se escribe en el input real de la ficha; el formulario es quien manda. */

    function inputCantidad() {
      return raiz.querySelector('input[name="quantity"]');
    }

    function cantidad() {
      var i = inputCantidad();
      var n = i ? parseInt(i.value, 10) : 1;
      return (n && n > 0) ? n : 1;
    }

    function ponerCantidad(n) {
      if (n < 1) { n = 1; }
      var i = inputCantidad();
      if (i && parseInt(i.value, 10) !== n) {
        i.value = String(n);
        i.dispatchEvent(new Event('input', { bubbles: true }));
        i.dispatchEvent(new Event('change', { bubbles: true }));
      }
      refrescar();
    }

    elMenos.addEventListener('click', function () { ponerCantidad(cantidad() - 1); });
    elMas.addEventListener('click', function () { ponerCantidad(cantidad() + 1); });

    /* ---------- estado ---------- */

    function precio() {
      var add = document.querySelector('.pn-pack__add');
      if (add) {
        var m = (add.textContent || '').match(/€\s*[\d.,]+|[\d.,]+\s*€/);
        if (m) { return m[0].replace(/\s+/g, '').trim(); }
      }
      var p = raiz.querySelector('[data-precio]');
      return p ? p.textContent.trim() : '';
    }

    function faltaElegir() {
      var ops = opciones();
      for (var i = 0; i < ops.length; i++) {
        var alguno = false;
        for (var j = 0; j < ops[i].valores.length; j++) {
          if (ops[i].valores[j].activo) { alguno = true; break; }
        }
        if (!alguno) { return true; }
      }
      return false;
    }

    function texto(el, t) {
      if (el.textContent !== t) { el.textContent = t; }
    }

    function refrescar() {
      pintarOpciones();
      texto(elNombre, nombreBase);
      texto(elQtyNum, String(cantidad()));
      elMenos.disabled = cantidad() <= 1;

      var d = destino();
      if (d && d.disabled) {
        texto(elBoton, raiz.getAttribute('data-agotado') || 'AGOTADO');
        elBoton.disabled = true;
      } else if (faltaElegir()) {
        texto(elBoton, 'ELEGIR TALLA');
        elBoton.disabled = false;
      } else {
        texto(elBoton, 'AÑADIR · ' + precio());
        elBoton.disabled = false;
      }
    }

    elBoton.addEventListener('click', function () {
      if (faltaElegir()) {
        var caja = document.querySelector('.pn-pack__sizes') || raiz.querySelector('[data-grupo]');
        if (caja) {
          caja.scrollIntoView({ behavior: 'smooth', block: 'center' });
          caja.classList.add('pn-barra-resalte');
          setTimeout(function () { caja.classList.remove('pn-barra-resalte'); }, 1300);
        }
        return;
      }
      var d = destino();
      if (d) { d.click(); }
    });

    /* ---------- visibilidad ---------- */

    var botonVisible = true;
    var observado = null;

    var io = new IntersectionObserver(function (entradas) {
      botonVisible = entradas[0].isIntersecting;
      pintar();
    }, { threshold: 0 });

    function reobservar() {
      var d = destino();
      if (!d || d === observado) { return; }
      if (observado) { io.unobserve(observado); }
      observado = d;
      botonVisible = false;
      io.observe(d);
      pintar();
    }

    function drawerAbierto() {
      var d = document.querySelector('#cart-drawer');
      return !!(d && (d.hasAttribute('open') || d.open === true));
    }

    function pintar() {
      var mostrar = !botonVisible &&
        desplazamiento() > MIN_SCROLL &&
        !drawerAbierto();
      barra.classList.toggle('pn-barra--visible', mostrar);
    }

    window.addEventListener('scroll', pintar, { passive: true });
    window.addEventListener('resize', pintar, { passive: true });
    var cont = contenedor();
    if (cont) { cont.addEventListener('scroll', pintar, { passive: true }); }
    document.addEventListener('click', function () { setTimeout(refrescar, 60); }, true);

    var espera;
    new MutationObserver(function () {
      clearTimeout(espera);
      espera = setTimeout(function () { reobservar(); refrescar(); pintar(); }, 120);
    }).observe(raiz, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'disabled', 'value'] });

    var drawer = document.querySelector('#cart-drawer');
    if (drawer) {
      new MutationObserver(pintar).observe(drawer, { attributes: true, attributeFilter: ['open'] });
    }

    /* El bloque de packs lo construye pn-pack.js despues de un fetch. */
    var intentos = 0;
    var tic = setInterval(function () {
      reobservar();
      refrescar();
      if (++intentos > 24) { clearInterval(tic); }
    }, 400);

    reobservar();
    refrescar();
    pintar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
  document.addEventListener('shopify:section:load', arrancar);
})();
